import React, { useEffect, useState } from 'react';
import {
  KoTitle, KoText,
  KoModal, KoButton, KoLoader,
  KoToast,
  KoKanban,
  KoEmpty,
  KoTabs,
  KoDrawer
} from 'packages';
import { ClientsAPI } from '../customers.service';
import styles from './leads.module.scss';
import KoIcon from '@kwapio/icons';
import Preview from '../customersList/deatils/preview';
import Comments from '../customersList/comments';

function Clients() {
  const [groupsRowList, setGroupsDataList] = useState();
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [openComments, setOpenComments] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [isLoading, setLoading] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isOpenCommentsModalNew, setCreateCommentNew] = useState(false);
  const [workflows, setWorkflows] = useState([]);
  const [accountType, setAccountType] = useState([]);


  useEffect(() => {
    const init = async() => {
      try {
        const workflowsRes = await getWorkflows();
        const accountTypes = await getAccountType();
        await getGroupByClients(accountTypes, workflowsRes);
      } catch (error) {
        console.error('Initialization error:', error);
      }
    };
    init();
  }, []);


  const getWorkflows = async() => {
    try {
      const res = await ClientsAPI.getCustomerWorkflow();
      if (res) {
        setWorkflows(res);
        return res;
      }
      return [];
    } catch (error) {
      console.error('Error fetching workflows:', error);
      return [];
    }
  };


  const getAccountType = async() => {
    try {
      const res = await ClientsAPI.getCustomerTypes();
      if (res) {
        setAccountType(res);
        return res;
      }
      return [];
    } catch (error) {
      console.error('Error fetching account types:', error, accountType);
      return [];
    }
  };



  const ModifyTheLabel = async(status) => {
    const statusObject = workflows?.find(item => item.label === status);
    return statusObject ? statusObject.value : null;
  };

  const UpdateStatus =async(newStatus) => {
    const {cardId, columnHeader, currentCardData} = newStatus;
    const newStatusValue = await ModifyTheLabel(columnHeader);
    if(!newStatusValue) return;
  
    const updatedValues = {
      status: newStatusValue
    };
  
    ClientsAPI.updateFileds(updatedValues, currentCardData?.customerId)
      .then(
        (data) => {
          KoToast.success(`${cardId} status updated successfully`);
          getGroupByClients();
        },
        (err) => {
        }
      );
 
  };

  const getCards = (tickets, wo) => {
    var mapped =tickets?.map(item => ({ 'id': item.customerId, 'summary': item.companyName, 'status': item.status, ...item}) );
    const groups =mapped.reduce((groups, item) => {
      const group = (groups[item.status] || []);
      group.push(item);
      groups[item.status] = group;
      return groups;
    }, {});
    const initializeBoard = wo?.filter(status => status.label && status.label.trim() !== "")
      .map(status => ({
        id: status.value,
        label: status.label,
        background: status.background,
        color: status.color,
        cards: []
      }));
        
    const populateBoardWithTickets = (tickets) => {
      const board = { columns: initializeBoard };
      if (!tickets) return board;
      Object.entries(tickets).forEach(([status, cards]) => {
        const column = board.columns.find(col =>
          col.id === parseInt(status)
        );
        if (column) {
          column.cards = cards;
        }
      });
          
      return board;
    };
    const populatedBoard = populateBoardWithTickets(groups);
    return populatedBoard;
  };

  const onCardClick = (row, source) => {
    let rowObject = {...row};
    setCurrentRecord(rowObject);
    if(source === 'open'){
      setOpenCustomerModal(true);
    }else if(source === 'comments'){
      setOpenComments(true);
    }

  };
    
  const getGroupByClients = (type, flow) => {
    setLoading(true);
    let q = {};
    q['groupedBy'] = 'type';
    ClientsAPI.getGroupByClients(q).then(
      (data) => {
        let tickets = [];
        for (let index = 0; index < data?.length; index++) {
          const element = data[index];
          const cards = getCards(element?.data ? element?.data : [], flow);
          tickets.push({
            key: element?.type?.label,
            label: <div className={styles.assignee}>
              <KoIcon className={styles.dp} width={24} height={24} name={element?.['type'].icon} />
              <div className={styles.info}>
                <KoText className={styles.text} ellipsis={true} text={`${element?.type?.label}`} />
                <KoText className={styles.textTicket} ellipsis={true} text={`${element?.count} Customers`} />
              </div>
            </div>,
            children:cards ? <KoKanban
              initialBoard={cards}
              getTickets={()=>setGroupsDataList()}
              onCardDragEnd={(UpdateStatus)}
              source='customers'
              onNewCardConfirm={draftCard => ({
                id: new Date().getTime(),
                ...draftCard
              })}
              onCardClick={onCardClick}
              onCardNew={()=>{}}
              workflow={type}
            /> : <></>
          });
        }
        setGroupsDataList();
        setLoading(false);
        setGroupsDataList(tickets);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  // const onSearchText=(text)=>{
  //   let q = pagination;
  //   if(text){
  //     q['search'] = text;
  //   }
  //   else{
  //     delete q?.['search'];
  //   }
  //   getClients(q);
  // };

  const handleFinishDelete = () => {
    setLoading(true);
    ClientsAPI.deleteById(currentRecord?.customerId).then(
      (data) => {
        KoToast.success('Delete successfully');
        setDeleteModal(false);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };



  return <div className={`${styles.wrapper} profileSection`}>
    {isLoading && <KoLoader />}
    <div className={styles.customerList}>
      <div className={styles.tableData}>
        {groupsRowList && groupsRowList?.length > 0 ? <KoTabs  options={groupsRowList} defaultActiveKey={['1']}  />: <KoEmpty  title="No tickets found" label="Create a new ticket"  />}

      </div>
    </div>
    <KoModal
      title={`${currentRecord?.companyName}`}
      centered
      open={openCustomerModal}
      afterClose={() => {setCurrentRecord();}}
      handleOk={() => { setCurrentRecord(); setOpenCustomerModal(false); }}
      onClose={() => { setCurrentRecord(); setOpenCustomerModal(false); }}
      width={'99vw'}
      height={'97vh'}
      footer={[]}
    >
      <div className={styles.delWrapper}>
        <Preview settings={currentRecord} form={''} getByIdSettings={getGroupByClients} />
      </div>
    </KoModal>
    <KoModal
      title={`Delete Customer ${currentRecord?.companyName?.toUpperCase()}`}
      centered
      open={isOpenDelete}
      afterClose={() => {setCurrentRecord();}}
      handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
      onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
      width={580}
      // maskClosable={false}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
        <KoButton key='reset' loading={isLoading}color="danger" variant="solid"  type='primary' label='Delete' onClick={() => handleFinishDelete()} />
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      <div className={styles.delWrapper}>
        <KoTitle level={5} text={`Are you sure you want to delete this Customer?`} />
        <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
      </div>
    </KoModal>
    <KoDrawer
      placement="right"
      closable={false}
      title={
        <div className={styles.headerTitle}>
          <KoTitle text={'Comments'} level={4} className={styles.title} />
          <KoButton type='primary' icon={<KoIcon color="#FFF" width={18} height={18} name={'PlusOutlined'} />} label={'Add a Comment'} onClick={() => setCreateCommentNew(true)} />
        </div>
      }
      onClose={() => setOpenComments(false)}
      open={openComments}
      width={750}
      footer={false}
    >
      {(openComments ) && <Comments className={`${styles.wrapperOverflow} `} classNameMain={styles.wrapperOverflow} emptyRowHeight={`${styles.wrapperOverflow} `} customerId={currentRecord?.customerId} setCreateComment={setCreateCommentNew} isOpenCommentsModal={isOpenCommentsModalNew} />}
    </KoDrawer>
  </div>;
}

export default Clients;
